export class CookieHint {
  constructor(Cookie) {
    Cookie.delete('style');

    // Cookie callout
    if (Cookie.get('cookie-hint-closed') == null) {
      $('.c-cookie').removeClass('c-cookie--closed');
    }

    $('.c-cookie__button button').on('click', function () {
      Cookie.set('cookie-hint-closed', 1, 7);
      $('.c-cookie').addClass('c-cookie--closed');
    });
  }
}
